import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { toast } from "sonner";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = location.hash || "";
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");
    if (!sessionId) {
      navigate("/");
      return;
    }

    (async () => {
      try {
        await api.post("/auth/session", { session_id: sessionId });
        window.history.replaceState(null, "", "/dashboard");
        navigate("/dashboard", { replace: true });
      } catch (e) {
        toast.error("Sign-in failed. Try again.");
        navigate("/", { replace: true });
      }
    })();
  }, [location, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background" data-testid="auth-callback">
      <div className="text-center">
        <div className="font-serif text-3xl italic text-primary">Opening your diary…</div>
        <p className="mt-4 text-xs uppercase tracking-[0.3em] text-muted-foreground">One moment</p>
      </div>
    </div>
  );
}
